var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _path11, _path12, _g2, _path13, _path14, _path15, _path16, _path17, _path18, _g3, _g4, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopLg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1292,
    height: 1050,
    viewBox: "0 0 1292 1050",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M517.241 241.032L444.33 283.065L272.223 183.217L347.774 141.185L517.241 241.032Z",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M517.241 463.045L444.33 505.089L272.223 405.242L347.774 363.209L517.241 463.045Z",
    stroke: "#231F20",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M516.82 463.045L443.909 505.089L271.812 405.242L347.352 363.209L516.82 463.045Z",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M444.328 283.064V505.09",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M348.426 141.185V363.21L272.301 405.176V183.151",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M517.242 240.292V462.317",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1129.21 774.813L897.49 908.411L350.555 591.11L590.626 457.502L1129.21 774.813Z",
    fill: "#C1282D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M372.101 323.066L299.189 365.099L127.082 265.263L202.622 223.219L372.101 323.066Z",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.101 545.09L299.189 587.123L127.082 487.276L202.622 445.243L372.101 545.09Z",
    stroke: "#231F20",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.679 545.09L298.768 587.123L126.672 487.276L202.212 445.243L371.679 545.09Z",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.188 365.099V587.124",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.285 223.219V445.244L127.16 487.211V265.185",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.102 322.337V544.362",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M982.128 352.034L909.217 394.077L737.109 294.23L812.649 252.197L982.128 352.034Z",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M982.128 574.058L909.217 616.102L737.109 516.255L812.649 474.222L982.128 574.058Z",
    stroke: "#231F20",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M981.707 574.058L908.795 616.102L736.699 516.255L812.239 474.222L981.707 574.058Z",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M909.215 394.077V616.102",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M813.313 252.197V474.223L737.188 516.189V294.164",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M982.129 351.305V573.33",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1208.07 477.303L1135.15 519.347L963.047 419.5L1038.59 377.456L1208.07 477.303Z",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1208.07 699.328L1135.15 741.372L963.047 641.524L1038.59 599.48L1208.07 699.328Z",
    stroke: "#231F20",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1207.64 699.328L1134.73 741.372L962.637 641.524L1038.18 599.48L1207.64 699.328Z",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.15 519.347V741.372",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1039.25 377.456V599.481L963.125 641.448V419.423",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1208.07 476.574V698.599",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M576.523 201.882L649.435 243.915L821.542 144.079L746.002 102.035L576.523 201.882Z",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M576.523 423.907L649.435 465.94L821.542 366.103L746.002 324.06L576.523 423.907Z",
    stroke: "#231F20",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M576.941 423.907L649.853 465.94L821.949 366.103L746.409 324.06L576.941 423.907Z",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M649.434 243.915V465.94",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M745.34 102.035V324.06L821.465 366.027V144.002",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M576.523 201.153V423.179",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416.062 101.847L488.974 143.88L661.07 44.0439L585.53 2L416.062 101.847Z",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.062 323.872L488.974 365.905L661.07 266.057L585.53 224.024L416.062 323.872Z",
    stroke: "#231F20",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.473 323.872L489.384 365.905L661.491 266.057L585.951 224.024L416.473 323.872Z",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.879 2V224.025L661.004 265.992V43.9666",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.062 323.132V101.118L488.974 143.88V365.905",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M587.48 783.802L660.392 825.835L832.488 725.999L756.948 683.955L587.48 783.802Z",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.48 1005.83L660.392 1047.86L832.488 948.012L756.948 905.979L587.48 1005.83Z",
    stroke: "#231F20",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.898 1005.83L660.81 1047.86L832.906 948.012L757.366 905.979L587.898 1005.83Z",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.391 825.835V1047.86",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.297 683.955V905.98L832.422 947.947V725.922",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.48 783.073V1005.09",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M444.324 684.221L517.236 726.265L689.332 626.418L613.792 584.385L444.324 684.221Z",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M444.324 906.246L517.236 948.29L689.332 848.442L613.792 806.398L444.324 906.246Z",
    stroke: "#231F20",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M444.734 906.246L517.657 948.29L689.753 848.442L614.213 806.398L444.734 906.246Z",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M517.234 726.265V948.29",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M613.141 584.385V806.399L689.266 848.366V626.351",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M444.324 683.492V905.518",
    stroke: "white",
    strokeWidth: 3.37941,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M184.363 591.011V775.377",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M197.859 573.903V777.883",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M204.621 607.201V732.725",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M211.367 617.273V719.274",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M191.059 607.246V752.384",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M150.605 610.569V794.946",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M157.301 626.814V771.953",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M218.125 623.48V707.822",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M164.047 632.701V758.225",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M170.801 639.405V741.395",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M177.551 640.543V724.885",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M231.633 643.69V673.111",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M238.379 615.638V688.361",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M245.129 609.751V682.475",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M224.816 640.322V681.505",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M251.887 608.936V681.659",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M265.395 598.101V680.565",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M272.141 578.421V686.297",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M278.891 569.209V696.699",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M258.578 622.387V663.58",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M285.648 583.259V695.056",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M299.156 565.29V675.121",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M305.902 546.537V683.834",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M312.652 570.337V652.801",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M292.34 602.63V649.334",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M319.41 567.046V649.51",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M332.918 558.155V640.609",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M339.664 577.869V619.063",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M346.414 554.854V637.318",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M326.102 582.076V628.781",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M354.859 549.95V632.414",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M368.367 541.06V623.513",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M375.113 535.991V618.456",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M381.859 546.735V604.837",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M361.555 563.291V609.995",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M388.621 543.6V601.701",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M402.129 535.637V593.738",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M408.875 537.328V579.339",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M415.621 522.727V589.045",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M395.316 551.309V584.219",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M422.383 524.55V582.651",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M435.887 516.598V574.699",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M442.637 518.784V553.837",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M449.387 504.803V554.61",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M429.074 532.269V565.179",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M456.145 511.43V550.403",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M469.648 504.857V553.627",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M476.398 504.416V532.026",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M483.145 496.497V529.364",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M462.832 518.012V545.632",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M489.906 493.848V526.703",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M503.41 483.268V532.269",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M510.16 483.268V532.269",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M516.918 475.548V507.332",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M496.594 496.486V524.228",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M523.664 468.304V515.483",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M530.414 461.545V508.724",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M537.172 461.102V508.281",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M543.922 464.759V498.1",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M557.426 462.526V484.095",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M564.176 446.281V493.361",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M570.934 430.322V503.046",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M577.625 443.83V480.959",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M584.441 423.563V496.287",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M550.609 457.733V498.916",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.42 683.161V859.465",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M1109.92 663.271V858.339",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M1103.17 701.35V821.385",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M1096.41 707.546V805.074",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M1116.73 698.534V837.333",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M1157.18 704.729V881.032",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M1150.49 715.044V853.843",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M1089.66 712.228V792.881",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M1143.73 724.045V844.08",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.98 730.24V827.768",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.23 734.924V815.577",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M1076.16 728.551V756.679",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M1069.41 706.419V775.962",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M1062.65 702.477V772.02",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M1082.97 728.551V767.933",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M1055.9 698.534V768.077",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.39 686.782V765.635",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M1035.64 666.274V769.435",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M1028.89 654.458V776.371",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.21 708.099V747.492",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M1022.14 658.213V765.117",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M1008.63 650.714V755.741",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M1001.89 631.388V762.688",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M995.125 658.698V737.551",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.45 684.662V729.323",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M988.379 654.004V732.857",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M974.871 645.5V724.353",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M968.125 667.589V706.982",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M961.367 639.118V717.971",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M981.688 666.771V711.433",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M952.93 626.361V705.214",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M939.422 617.848V696.712",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M932.672 617.848V696.712",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M925.914 623.28V678.842",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M946.234 639.118V683.779",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M730.105 482.648V589.564",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M716.602 473.46V578.498",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M709.848 459.203V590.503",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M703.094 483.135V561.999",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M723.402 512.479V557.14",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M696.348 478.451V557.304",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M682.84 468.247V547.111",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M676.082 485.277V524.671",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M669.332 461.876V540.729",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M689.641 489.519V534.18",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M660.898 459.236V538.089",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M647.395 445.663V524.527",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M640.633 445.663V524.527",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M633.883 451.097V506.658",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M654.195 470.312V514.974",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M919.168 620.288V675.85",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M905.66 614.291V669.853",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M898.914 614.291V654.457",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M892.156 601.944V665.358",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M912.473 629.278V660.742",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M885.406 605.302V660.863",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M871.898 599.304V654.865",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M865.152 596.556V630.074",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M858.395 583.181V630.813",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M878.711 614.291V645.755",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M851.645 589.521V626.793",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M838.141 583.235V629.873",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M831.391 582.816V609.211",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M824.633 575.239V606.67",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M844.949 595.815V622.232",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M817.883 572.7V604.131",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M804.379 562.596V609.444",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M797.629 552.469V599.317",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M790.871 556.896V587.289",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M811.188 575.229V601.767",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M784.121 545.201V590.315",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M777.363 541.821V586.935",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M770.617 538.166V583.291",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M763.867 540.044V571.927",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M750.363 537.979V558.619",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M743.602 519.226V564.24",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M736.855 504.03V573.573",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M757.164 533.107V572.49",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M191.059 217.619L1290 869.481",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "8.37 8.37"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M592.823 455.924L2 784.423",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "8.37 8.37"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M1256.24 172.328L665.402 500.827",
    stroke: "#C1282D",
    strokeWidth: 2.52904,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "8.37 8.37"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopLg);
export default __webpack_public_path__ + "static/media/desktop-lg.89f88ca87f8bf7bf9648ce56b0e174bb.svg";
export { ForwardRef as ReactComponent };